import * as React from 'react';
import ReactTable from 'react-table';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';
import Renderers from '../../../sys/columns';

class State {
    data: any;
    options: Array<string>;
    buildVer: string;
    upTime: number;
    name: string;
    sysTime: any;
    macAddr: any;
    ipAddr: any;
    subnet: any;
    gatewayIP: any;
    dhcpStatus: any;
    serial: any;
    ram: any;
    virtulization: any;
    biosVer: any; biosDate: any;
    fileSysTotal: any; fileSysUsed: any;
}

interface Props {

}

export default class SystemStatusPanel extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            data: []
        });
    }
    render() {
        const columns = [
            {
                Header: 'Name',
                accessor: 'name',
                width: 500,
                headerStyle: { textAlign: 'left' }
            },
            {
                Header: 'Value',
                accessor: 'value',
                headerStyle: { textAlign: 'left' },
                Cell: (props: any) => this.renderer(props)
            }
        ];
        return (
            <ReactTable
                className=" -striped -highlight -padded"
                onFetchData={() => this.fetchData()}
                data={(this.state && this.state.data) ? this.state.data : []}
                columns={columns}
                defaultPageSize={14}
                showPagination={false}
            />
        );
    }

    renderer(props: any) {

        if (props.original.name === 'System Up Time') {
            let utc = Math.round(+new Date() / 1000);
            return Renderers.timestamp.durationAndSince( utc - props.value);
        }

        return props.value;
    }

    buildDataArr() {
        let dataArr = [
            {name: 'Build Version', value: this.state.buildVer},
            // {name: 'System Up Time', value: this.state.upTime},
            {name: 'System Name', value: this.state.name},
            // {name: 'System Time and Date', value: this.state.sysTime},
            {name: 'MAC Address', value: this.state.macAddr},
            {name: 'IP Address', value: this.state.ipAddr},
            {name: 'Subnet Mask', value: this.state.subnet},
            {name: 'Gateway IP', value: this.state.gatewayIP},
            {name: 'DHCP Status', value: this.state.dhcpStatus},
            {name: 'Serial Number', value: this.state.serial},
            {name: 'RAM', value: this.state.ram},
            {name: 'Virtualization', value: this.state.virtulization},
            {name: 'BIOS Version', value: this.state.biosVer},
            {name: 'BIOS Release Date', value: this.state.biosDate},
            {name: 'File System Total', value: this.state.fileSysTotal},
            {name: 'File System Used', value: this.state.fileSysUsed}
        ];

        this.setState({
            data: dataArr
        });
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/sys/status';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    let responseObject = response.data;

                    let tot = responseObject.totalFS;
                    let used = responseObject.usedFS;
                    if (tot === 0) {
                        tot = 'N/A'; used = 'N/A';
                    } else {
                        let percent = (used / tot) * 100;
                        tot = tot.toLocaleString() + ' MB';
                        used = used.toLocaleString() + ' MB' + '  (' + (Math.round(percent * 100) / 100) + ' %)';
                    }

                    let ram = Math.trunc(responseObject.ram / 1000) + ' GB';

                    _this.setState({
                        buildVer: responseObject.ver,
                        upTime: responseObject.uptime,
                        name: responseObject.name,
                        sysTime: responseObject.timestring,
                        macAddr: responseObject.macAddress,
                        ipAddr: responseObject.ipAddress,
                        subnet: responseObject.subnetMask,
                        gatewayIP: responseObject.gateway,
                        dhcpStatus: responseObject.dhcpStatus,
                        serial: responseObject.serialNumber,
                        ram: ram,
                        virtulization: responseObject.virtualization,
                        biosVer: responseObject.biosVersion,
                        biosDate: responseObject.biosDate,
                        fileSysTotal: tot,
                        fileSysUsed: used
                        },
                                   () => _this.buildDataArr()
                    );

                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/systemInfo/systemStatus.tsx